"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _MdChevronRight = require("@react-icons/all-files/md/MdChevronRight");

var _MdClose = require("@react-icons/all-files/md/MdClose");

var _propTypes = require("prop-types");

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = require("styled-components");

var _Link = require("./Link.styles");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Link = function Link(_ref) {
  var id = _ref.id,
      className = _ref.className,
      element = _ref.element,
      href = _ref.href,
      onClick = _ref.onClick,
      text = _ref.text,
      theme = _ref.theme,
      type = _ref.type;

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      icon = _useState2[0],
      setIcon = _useState2[1];

  var elementType = element === 'button' ? 'button' : undefined;

  if (element === 'a' && !href) {
    throw new Error("Please provide a value for the href attribute.");
  }

  var iconObj = theme.link.types[type].icon;
  var iconCode = iconObj ? iconObj.code : undefined;
  var iconPosition = iconObj ? iconObj.position : undefined;
  (0, _react.useEffect)(function () {
    var icons = {
      MdChevronRight: _MdChevronRight.MdChevronRight,
      MdClose: _MdClose.MdClose
    };
    setIcon(icons[iconCode]);
  }, [iconCode]);
  return /*#__PURE__*/_react["default"].createElement(_Link.StyledLink, {
    as: element,
    className: className,
    href: href,
    id: id,
    linkType: type,
    onClick: onClick,
    role: "button",
    type: elementType
  }, iconPosition === 'before' && /*#__PURE__*/_react["default"].createElement(_Link.StyledLinkIcon, {
    linkType: type
  }, icon), /*#__PURE__*/_react["default"].createElement(_Link.StyledLinkLabel, null, text), iconPosition === 'after' && /*#__PURE__*/_react["default"].createElement(_Link.StyledLinkIcon, {
    linkType: type
  }, icon));
};

Link.defaultProps = {
  id: '',
  className: null,
  element: 'a',
  href: undefined,
  onClick: function onClick() {
    return null;
  },
  type: 'standard'
};
Link.propTypes = {
  /** Custom Id that allows us to retrieve this element in the dom. */
  id: _propTypes.string,

  /** Output HTML element */
  element: (0, _propTypes.oneOf)(['a', 'button']),

  /** Custom class to be added to the container */
  className: _propTypes.string,

  /** The link href */
  href: _propTypes.string,

  /** The link label */
  onClick: _propTypes.func,

  /** The text of the link */
  text: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.node]).isRequired,

  /** Theme object. Passed automatically by the ThemeProvider high-order component */
  theme: (0, _propTypes.shape)({}).isRequired,

  /** The type of link. Possible values: */
  type: (0, _propTypes.oneOf)(['anchor', 'high-visibility', 'standard', 'remove'])
};
Link.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Link",
  "props": {
    "id": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "Custom Id that allows us to retrieve this element in the dom.",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "className": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "Custom class to be added to the container",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "element": {
      "defaultValue": {
        "value": "'a'",
        "computed": false
      },
      "description": "Output HTML element",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'a'",
          "computed": false
        }, {
          "value": "'button'",
          "computed": false
        }]
      },
      "required": false
    },
    "href": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "The link href",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "onClick": {
      "defaultValue": {
        "value": "() => null",
        "computed": false
      },
      "description": "The link label",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "type": {
      "defaultValue": {
        "value": "'standard'",
        "computed": false
      },
      "description": "The type of link. Possible values:",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'anchor'",
          "computed": false
        }, {
          "value": "'high-visibility'",
          "computed": false
        }, {
          "value": "'standard'",
          "computed": false
        }, {
          "value": "'remove'",
          "computed": false
        }]
      },
      "required": false
    },
    "text": {
      "description": "The text of the link",
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "node"
        }]
      },
      "required": true
    },
    "theme": {
      "description": "Theme object. Passed automatically by the ThemeProvider high-order component",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": true
    }
  }
};

var _default = (0, _styledComponents.withTheme)(Link);

exports["default"] = _default;